import axios from 'axios'
import qs from 'qs'

import WxJsSdk from 'weixin-js-sdk'
import store from '@/store/store'
import { Dialog } from 'vant'

let util = {}

util.title = function (title) {
    title = title || '视频双选会'
    window.document.title = title
}

// 平台、设备和操作系统 ，返回ture或false,true表示是移动端，false表示不是移动端
util.ismobile = function (check) {
    var mobileArry = ['iPhone', 'iPad', 'Android', 'Windows Phone', 'BB10 Touch', 'BB10 Touch', 'PlayBook', 'Nokia']
    var ua = navigator.userAgent

    if (check === 'isAndroid') {
        return ua.indexOf("Android") > -1 || ua.indexOf("Adr") > -1; // android终端
    } else if (check === 'isIos') {
        return !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // ios终端
    }

    var res = mobileArry.filter(function (arr) {
        return ua.indexOf(arr) > 0
    })
    return res.length > 0
}

const picUrl = 'https://o.bysjy.com.cn/'
const picPath = 'http://pic.bibibi.net/'
const aliPath = 'http://yun-campus-res.oss-cn-shenzhen.aliyuncs.com/'
const error_img_sm = 'http://o.bysjy.com.cn/company/98762/1564037265-8660.png'

const env = 'production'
const ajaxUrl = env === 'development' ? 'http://localhost:9081/' : env === 'production' ? 'https://s.bysjy.com.cn/' : 'https://s.bysjy.com.cn/'

util.ajax = axios.create({
    baseURL: ajaxUrl,
    timeout: 30000
})

util.post = function (control, action, params) {
    let url = control.indexOf('http') >= 0 ? control : ajaxUrl + 'index.php?r=' + control + '/ajax_' + action
    return axios.post(url, qs.stringify(params)).then((response) => {
        const { data } = response
        const { msg } = data
        return util.goToLogin(msg).then(() => {
            return data
        })
    }, function (error) {
        const { response } = error
        if (!response) return
        // if ([401].indexOf(response.status) >= 0) {}
        if (response.hasOwnProperty('data')) {
            return Promise.reject(response.data)
        } else {
            return Promise.reject(response)
        }
    })
}

util.get = function (control, action, params) {
    let url = control.indexOf('http') >= 0 ? control : ajaxUrl + 'index.php?r=' + control + '/ajax_' + action
    return axios.get(url, {
        params: params
    }).then((response) => {
        const { data } = response
        const { msg } = data
        return util.goToLogin(msg).then(() => {
            return data
        })
    }, function (error) {
        const { response } = error
        if (!response) return
        // if ([401].indexOf(response.status) >= 0) {}
        if (response.hasOwnProperty('data')) {
            return Promise.reject(response.data)
        } else {
            return Promise.reject(response)
        }
    })
}

util.goToLogin = function (msg) {
    return new Promise((resolve) => {
        if (msg) {
            if (msg.indexOf('请登录') >= 0) {
                store.commit('updateLoginState')
            }
        }
        resolve()
    })
}

util.getQueryString = function (name) {
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
    var r = window.location.search.substr(1).match(reg)
    if (r != null) return decodeURIComponent(r[2])
    return ''
}

util.isArrayFn = function (value) {
    if (typeof Array.isArray === 'function') {
        return Array.isArray(value)
    } else {
        return Object.prototype.toString.call(value) === '[object Array]'
    }
}

util.reg = {
    'url': /^((https|http|ftp|rtsp|mms)?:\/\/)[^\s]+/
}

util.regTest = function (opts, name) {
    let regs, str
    if (typeof opts === 'string') {
        str = opts
    } else {
        str = opts.str
        regs = opts.regs
    }
    const reg = regs || util.reg[name]
    return reg.test(str)
}

util.ishttps = function () {
    return 'https:' == document.location.protocol ? true : false
}

// 获取用户的 云就业openid
util.getOpenId = function (data, no_silent) {
    let url, back
    if (typeof data === 'string') {
        back = data
    } else if (data) {
        url = data.url
        back = data.back
    }
    let return_url = url ? url : location.href

    if (back) {
        return_url += '?back=' + encodeURIComponent(back)
    }

    location.href = "https://m.bysjy.com.cn/student/kzp/bind.html?token=yunyan1536161856&return_url=" + encodeURIComponent(return_url) + (no_silent ? '' : "&silent=true")
}

// 微信事件、方法处理
util.jweixin = function (params, wechat, fn, fail) {
    util.getSignPackage(params, function (sign) {
        util.bindWX(sign, wechat, function (wx) {
            fn(wx)
        }, fail)
    }, fail)
}

util.isWeiXin = function () {
    var ua = window.navigator.userAgent.toLowerCase()
    if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        return true
    } else {
        return false
    }
}

util.getSignPackage = function (params, callback, fail) {
    if (util.isWeiXin()) {
        if (util.getQueryString('t_') === '1') {
            fail ? fail('1') : null
            return
        }
        util.get('kzp', 'sign_package', params).then(function (result) {
            if (result && result.code === 1) {
                callback(result.data)
            } else {
                fail ? fail('2') : null
            }
        })
    } else {
        fail ? fail('不是微信') : null
    }
}

util.bindWX = function (sign, wechat, fn, fail) {
    let wx = wechat
    wx.config({
        appId: sign.appId,
        timestamp: sign.timestamp,
        nonceStr: sign.nonceStr,
        signature: sign.signature,
        debug: true,
        jsApiList: [
            'onMenuShareTimeline',
            'onMenuShareAppMessage',
            'onMenuShareQQ',
            'onMenuShareWeibo',
            'hideMenuItems',
            'showMenuItems',
            'getLocation',
            'chooseImage',
            'previewImage',
            'uploadImage',
            'downloadImage',
            'openLocation'
        ]
    })
    wx.ready(function () {
        wx.checkJsApi({
            jsApiList: [
                'checkJsApi',
                'chooseImage',
                'previewImage',
                'uploadImage',
                'downloadImage',
                'openLocation'
            ],
            success: function (res) {
                //如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
                if (res.errMsg == 'checkJsApi:ok') {
                    if (fn) {
                        fn(wx)
                    }
                } else {
                    fail ? fail('您当前的微信版本过低') : null
                    alert('您当前的微信版本过低')
                }
            },
            fail: (res) => {
                fail ? fail(res.errMsg) : null
            }
        })
    })

    wx.error(function (res) {
        fail ? fail(res.errMsg) : null
    });
}

util.getLocation = function (wx, callback) {
    wx.getLocation({
        type: 'wgs84', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
        success: function (res) {
            callback ? callback(res) : null
        },
        fail: function (res) {
            alert('获取地址失败:' + res)
        }
    })
}

util.openLocation = function (wx, data, callback) {
    const {
        latitude, longitude, scale, address, infoUrl, name
    } = data
    wx.openLocation({
        latitude: latitude, // 纬度，浮点数，范围为90 ~ -90
        longitude: longitude, // 经度，浮点数，范围为180 ~ -180。
        name: name || '', // 位置名
        address: address || '', // 地址详情说明
        scale: scale || 1, // 地图缩放级别,整形值,范围从1~28。默认为最大
        infoUrl: infoUrl || '', // 在查看位置界面底部显示的超链接,可点击跳转,
        fail: (res) => {
            alert('fail:' + res.errMsg)
        }
    });

    callback ? callback() : null
}

util.wxShare = function (wx, share, callback) {
    // 监听“分享给朋友”
    wx.onMenuShareAppMessage({
        title: share.title,
        desc: share.desc,
        link: share.link,
        imgUrl: share.imgUrl,
        success: function () {
            callback ? callback() : null
        }
    })

    //监听“分享到朋友圈”
    wx.onMenuShareTimeline({
        title: share.title,
        link: share.link,
        imgUrl: share.imgUrl,
        success: function () {
            callback ? callback() : null
        }
    })

    //监听“分享到QQ”
    wx.onMenuShareQQ({
        title: share.title,
        desc: share.desc ? share.desc : share.title,
        link: share.link,
        imgUrl: share.imgUrl,
        fail: function (res) {
            alert('分享到QQ失败' + JSON.stringify(res))
            //console.log(JSON.stringify(res) +'onMenuShareQQ');
        },
        success: function () {
            callback ? callback() : null
        }
    })

    //监听“分享到微博”
    wx.onMenuShareWeibo({
        title: share.title,
        desc: share.desc,
        link: share.link,
        imgUrl: share.imgUrl,
        success: function () {
            callback ? callback() : null
        }
    })
}

//批量隐藏功能按钮接口
util.hideWXMenu = function (wx) {
    wx.hideMenuItems({
        menuList: [
            /*'menuItem:share:appMessage',   //发送给朋友,
             'menuItem:share:timeline',     //分享到朋友圈
             */
            'menuItem:share:qq',           //分享到QQ
            'menuItem:share:weiboApp',     //分享到Weibo
            'menuItem:share:facebook',     //分享到facebook
            'menuItem:share:QZone'         //分享到QQ空间
        ]
    })
}
//根据屏幕宽高比和图片宽度 计算图片适应高度
util.getHeight = function (width, height, ele) {
    let bw = window.screen.width;
    if (ele) {
        bw = ele.offsetWidt / ele.offsetHeight;
    }
    return bw * height / width;
}
util.getWidth = function (height) {
    return height * window.screen.width / window.screen.height;
}

util.getURLBase64 = function (url) {
    return new Promise((resolve, reject) => {
        var xhr = new XMLHttpRequest();
        xhr.open("get", url, true);
        xhr.responseType = "blob";
        xhr.onload = function () {
            if (this.status === 200) {
                var blob = this.response;
                var fileReader = new FileReader();
                fileReader.onloadend = function (e) {
                    var result = e.target.result;
                    resolve(result);
                };
                fileReader.readAsDataURL(blob);
            }
        };
        xhr.onerror = function () {
            reject();
        };
        xhr.send();
    });
}

util.goToWxProgram = function (url, kind) {
    if (!kind) {
        kind = 'reLaunch'
    }
    return new Promise((resolve) => {
        try {
            WxJsSdk.miniProgram[kind]({
                url,
                success: () => {
                    resolve('success')
                },
                fail: (res) => {
                    resolve('fail', res)
                },
                complete: (res) => {
                    resolve(res)
                }
            });
        } catch (e) {
            resolve('fail', e)
        }
    })
}

const getValue = (obj, cols, params) => {
    if (Object.prototype.toString.call(obj) === '[object Object]') {
        var url = '';
        (function getKeysFn(o, _index) {
            if (cols[_index]) {
                var key = cols[_index]
                if (Object.prototype.toString.call(o[key]) === '[object Object]') {
                    getKeysFn(o[key], _index + 1)
                } else {
                    url = o[key]
                    if (!url || url.indexOf('http') < 0) {
                        url = params.default_img || error_img_sm
                    } else if (url.indexOf('https') < 0) {
                        url = url.replace(aliPath, picUrl).replace(picPath, picUrl)
                    }
                    if (url.indexOf('x-oss-process') < 0) {
                        if (params.style) {
                            url += ('?x-oss-process=style/' + params.style)
                        } else if (params.resize) {
                            url += ('?x-oss-process=image/resize,m_fill,' + params.resize)
                        }
                    }
                    o[key] = url
                }
            }
        })(obj, 0)
    }
}

util.tansPics = function (array, col, params) {
    if (col) {
        let cols = col.indexOf('.') > -1 ? col.split('.') : [col]
        if (Array.isArray(array)) {
            for (let index in array) {
                getValue(array[index], cols, params)
            }
        } else {
            getValue(array, cols, params)
        }
    }
}

util.transformArrayBufferToBase64 = function (buffer) {
    var binary = "";
    var bytes = new Uint8Array(buffer);
    for (var len = bytes.byteLength, i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i]);
    }
    return window.btoa(binary);
}

util.getURLBase64 = function (url) {
    return new Promise((resolve, reject) => {
        var xhr = new XMLHttpRequest();
        xhr.open("get", url, true);
        xhr.responseType = "arraybuffer"; // blob
        xhr.onload = function () {
            console.log('onload')
            if (this.status === 200) {
                var blob = this.response;
                var fileReader = new FileReader();
                fileReader.onloadend = function (e) {
                    var result = e.target.result;
                    resolve(result);
                };
                fileReader.readAsDataURL(blob);
            }
        };
        xhr.onerror = function () {
            reject();
        };
        xhr.send();
    });
}

util.makesueTwice = function ({ title, message }) {
    // 二次确认窗口
    return new Promise(resolve => {
        let data = {
            title
        };

        if (message) {
            data.message = message;
        }

        Dialog
            .confirm(data)
            .then(() => {
                resolve(true);
            })
            .catch(() => {
                resolve(false);
            });
    });
}

util.formatDateTime = function (obj, type) {
    if (!obj) {
        return obj;
    }
    var myDate = new Date(obj);
    var y = myDate.getFullYear();
    var M = ("0" + (myDate.getMonth() + 1)).slice(-2);
    var d = ("0" + myDate.getDate()).slice(-2);
    var h = ("0" + myDate.getHours()).slice(-2);
    var m = ("0" + myDate.getMinutes()).slice(-2);
    var s = ("0" + myDate.getSeconds()).slice(-2);
    var mi = ("00" + myDate.getMilliseconds()).slice(-3);
    var current_date = '';
    if (type == "yyyy-MM-dd") {
        current_date = y + '-' + M + '-' + d;
    } else if (type == "yyyy-MM-dd HH:mm:ss") {
        current_date = y + '-' + M + '-' + d + ' ' + h + ':' + m + ':' + s;
    } else if (type == "HH:mm") {
        current_date = h + ':' + m;
    } else if (type == "yyyy/MM/dd") {
        current_date = y + '/' + M + '/' + d;
    } else if (type == "yyyy/MM/dd HH:mm:ss") {
        current_date = y + '/' + M + '/' + d + ' ' + h + ':' + m + ':' + s;
    } else if (type == "yyyy/MM/dd HH:mm:ss.s") {
        current_date = y + '/' + M + '/' + d + ' ' + h + ':' + m + ':' + s + '.' + mi;
    }
    return current_date;
}

// 
util.goToWxResume = function (msg) {
    if (msg && msg.indexOf('没有简历') >= 0) {
        util.makesueTwice({
            title: "您还没有简历?",
            message: "确认去新增简历?"
        }).then(res => {
            if (res) {
                util
                    .goToWxProgram(
                        "/pages/seeker/resume/main",
                        "navigateTo"
                    )
                    .then((state) => {
                        if (state === "fail") {
                            // 
                        }
                    });
            }
        });
    }
}

export default util
